import {
  BILLING_INFO_UPDATE_PAYMENT_INFO,
  BILLING_INFO_UPDATE_CARD_CONSENT,
  BILLING_INFO_UPDATE_ACH_CONSENT,
  BILLING_INFO_LOAD_ACH_INFO,
  BILLING_INFO_UPDATE_ACH_DEFAULT,
  BILLING_INFO_SET_EDITING_ACH,
  BILLING_INFO_UPDATE_CARD_PAYMENT_INFO,
  BILLING_INFO_UPDATE_ACH_PAYMENT_INFO,
  BILLING_INFO_SET_SELECTED_PAYMENT_METHOD,
  BILLING_INFO_OPEN_SAVE_DISCLAIMER,
  BILLING_INFO_CLOSE_SAVE_DISCLAIMER,
  BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS,
  BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS,
  BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS_FOR_BANNER,
  BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS_FOR_BANNER,
  BILLING_INFO_UPDATE_ADDRESS_INFO,
  BILLING_INFO_UPDATE_ADDRESS_INFO_ERRORS,
  BILLING_INFO_SHOW_ADDRESS_VALIDATION_ERRORS,
  BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS,
  BILLING_INFO_LOAD_ADDRESS_INFO,
  BILLING_INFO_RESET_PAGE,
  BILLING_INFO_RESET_ADD_PAYMENT_FORM,
  LOAD_BILLING_ACCOUNT_CONTEXT,
  LOAD_BILLING_INFO_START,
  LOAD_BILLING_INFO_COMPLETE,
  LOAD_BILLING_INFO_ERROR,
  BILLING_INFO_SUBMIT,
  BILLING_INFO_SUBMIT_START,
  BILLING_INFO_SUBMIT_COMPLETE,
  BILLING_INFO_SUBMIT_ERROR,
  PAYMENT_TOKEN_RESET,
  PAYMENT_TOKEN_SUCCESS,
  PAYMENT_TOKEN_ERROR,
  BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS_FOR_BANNER,
  BILLING_INFO_UPDATE_ADDRESS_INFO_FIELDS,
  BILLING_INFO_SUBMIT_RESET,
  BILLING_INFO_SUBMIT_VALIDATION_ERROR,
  LOAD_PAYMENT_METHODS,
  LOAD_PAYMENT_METHODS_START,
  LOAD_PAYMENT_METHODS_SUCCESS,
  LOAD_PAYMENT_METHODS_ERROR,
  SET_PAYMENT_METHOD_DEFAULT,
  SET_PAYMENT_METHOD_DEFAULT_SUCCESS,
  SET_PAYMENT_METHOD_DEFAULT_ERROR,
  REMOVE_PAYMENT_METHOD,
  REMOVE_PAYMENT_METHOD_SUCCESS,
  REMOVE_PAYMENT_METHOD_ERROR,
  REMOVE_PAYMENT_METHOD_BLOCKED_DEFAULT,
  RESET_PAYMENT_METHODS_ACTION_ERROR,
  SET_RECENTLY_ADDED_PAYMENT_METHOD,
  CLEAR_RECENTLY_ADDED_PAYMENT_METHOD,
} from 'constants/ActionTypes';

// #genai Phase 2 — deep-link account-context hydration for the Add-Card / Add-ACH routes.
export const loadBillingAccountContext = () => ({ type: LOAD_BILLING_ACCOUNT_CONTEXT });
export const loadBillingInfoStart = () => ({ type: LOAD_BILLING_INFO_START });
export const loadBillingInfoComplete = () => ({ type: LOAD_BILLING_INFO_COMPLETE });
export const loadBillingInfoError = () => ({ type: LOAD_BILLING_INFO_ERROR });
export const updatePaymentInfo = (paymentInfo) => ({ type: BILLING_INFO_UPDATE_PAYMENT_INFO, paymentInfo });
export const updateCreditCardConsent = (ccConsent) => ({ type: BILLING_INFO_UPDATE_CARD_CONSENT, ccConsent });
export const updateAchConsent = (achConsent) => ({ type: BILLING_INFO_UPDATE_ACH_CONSENT, achConsent }); // #genai
export const loadAchInfo = (achInfo) => ({ type: BILLING_INFO_LOAD_ACH_INFO, achInfo }); // #genai
export const updateAchDefault = (isACHDefault) => ({ type: BILLING_INFO_UPDATE_ACH_DEFAULT, isACHDefault }); // #genai
export const setEditingAch = (isEditingAch) => ({ type: BILLING_INFO_SET_EDITING_ACH, isEditingAch }); // #genai
export const updateCardPaymentInfo = (cardPaymentInfo) => ({ type: BILLING_INFO_UPDATE_CARD_PAYMENT_INFO, cardPaymentInfo }); // #genai
export const updateAchPaymentInfo = (achPaymentInfo) => ({ type: BILLING_INFO_UPDATE_ACH_PAYMENT_INFO, achPaymentInfo }); // #genai
// #genai
export const setSelectedPaymentMethod = (selectedPaymentMethod, persistSaved = false) => ({
  type: BILLING_INFO_SET_SELECTED_PAYMENT_METHOD,
  selectedPaymentMethod,
  persistSaved,
});
export const openSaveDisclaimer = () => ({ type: BILLING_INFO_OPEN_SAVE_DISCLAIMER }); // #genai
export const closeSaveDisclaimer = () => ({ type: BILLING_INFO_CLOSE_SAVE_DISCLAIMER }); // #genai
// #genai
export const updateCardPaymentInfoErrors = (cardPaymentInfoErrors) => ({
  type: BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS,
  cardPaymentInfoErrors,
});
// #genai
export const updateAchPaymentInfoErrors = (achPaymentInfoErrors) => ({
  type: BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS,
  achPaymentInfoErrors,
});
// #genai
export const updateCardPaymentInfoErrorsForBanner = (cardPaymentInfoErrorsForBanner) => ({
  type: BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS_FOR_BANNER,
  cardPaymentInfoErrorsForBanner,
});
// #genai
export const updateAchPaymentInfoErrorsForBanner = (achPaymentInfoErrorsForBanner) => ({
  type: BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS_FOR_BANNER,
  achPaymentInfoErrorsForBanner,
});
export const loadAddressInfo = (addressInfo) => ({ type: BILLING_INFO_LOAD_ADDRESS_INFO, addressInfo });
export const updateAddressInfo = (fieldId, value) => ({ type: BILLING_INFO_UPDATE_ADDRESS_INFO, fieldId, value });
export const updateAddressInfoFields = (addressInfo) => ({ type: BILLING_INFO_UPDATE_ADDRESS_INFO_FIELDS, addressInfo });
export const updateAddressInfoErrors = (fieldId, fieldErrorValue, bannerErrorValue) => ({
  type: BILLING_INFO_UPDATE_ADDRESS_INFO_ERRORS, fieldId, fieldErrorValue, bannerErrorValue,
});
export const updateAddressValidationErrorsForDisplay = () => ({ type: BILLING_INFO_SHOW_ADDRESS_VALIDATION_ERRORS });
export const updatePaymentInfoErrors = (paymentInfoErrors) => ({ type: BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS, paymentInfoErrors });
export const updatePaymentInfoErrorsForBanner = (paymentInfoErrorsForBanner) => ({
  type: BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS_FOR_BANNER,
  paymentInfoErrorsForBanner,
});
export const resetBillingInfoPage = () => ({ type: BILLING_INFO_RESET_PAGE });
// #genai Phase 2: wipe the card/ACH/address form slices the load saga hydrated so the dedicated
// /add-card and /add-ach routes always present an empty form for adding a NEW payment method.
export const resetAddPaymentFormState = () => ({ type: BILLING_INFO_RESET_ADD_PAYMENT_FORM });
export const submitBillingInfo = (transientTokenData) => ({ type: BILLING_INFO_SUBMIT, transientTokenData });
export const submitBillingInfoStart = () => ({ type: BILLING_INFO_SUBMIT_START });
export const resetBillingSubmission = () => ({ type: BILLING_INFO_SUBMIT_RESET });
export const submitBillingInfoValidationError = () => ({ type: BILLING_INFO_SUBMIT_VALIDATION_ERROR });
export const submitBillingInfoComplete = () => ({ type: BILLING_INFO_SUBMIT_COMPLETE });
// #genai errorCode (optional) lets the banner pick a curated FE translation when the backend
// returns a known ev-ecomm-orchestration-service code. Omitted/unknown codes fall back to
// the raw errorMessage from the API, then to the generic submit_fail_message.
export const submitBillingInfoError = (errorMessage, errorCode, errorType, supportReference) => ({
  type: BILLING_INFO_SUBMIT_ERROR,
  errorMessage,
  errorCode,
  errorType, // #genai Phase 2 — guide §4 branches UI on errorType, not errorCode
  supportReference, // #genai Phase 2 — orphan 503 support-contact reference
});
export const resetPaymentToken = () => ({ type: PAYMENT_TOKEN_RESET });
export const paymentTokenSuccess = (cardData, ccConsent) => ({ type: PAYMENT_TOKEN_SUCCESS, cardData, ccConsent });
export const paymentTokenError = (error) => ({ type: PAYMENT_TOKEN_ERROR, error });

// #genai Phase 2 — unified saved payment methods list (GET /v1/payment-methods).
export const loadPaymentMethods = () => ({ type: LOAD_PAYMENT_METHODS });
export const loadPaymentMethodsStart = () => ({ type: LOAD_PAYMENT_METHODS_START });
export const loadPaymentMethodsSuccess = (paymentMethods) => ({ type: LOAD_PAYMENT_METHODS_SUCCESS, paymentMethods });
export const loadPaymentMethodsError = (loadError) => ({ type: LOAD_PAYMENT_METHODS_ERROR, loadError });

// #genai Phase 2 — set default (PUT /v1/payment-methods/:type/:id/default).
export const setPaymentMethodDefault = ({ type, id }) => ({ type: SET_PAYMENT_METHOD_DEFAULT, method: { type, id } });
export const setPaymentMethodDefaultSuccess = ({ type, id }) => ({ type: SET_PAYMENT_METHOD_DEFAULT_SUCCESS, method: { type, id } });
export const setPaymentMethodDefaultError = ({ type, id }, actionError) => ({
  type: SET_PAYMENT_METHOD_DEFAULT_ERROR, method: { type, id }, actionError,
});

// #genai Phase 2 — remove (PUT /v1/payment-methods/:type/:id/remove).
export const removePaymentMethod = ({ type, id }) => ({ type: REMOVE_PAYMENT_METHOD, method: { type, id } });
export const removePaymentMethodSuccess = ({ type, id }) => ({ type: REMOVE_PAYMENT_METHOD_SUCCESS, method: { type, id } });
export const removePaymentMethodError = ({ type, id }, actionError) => ({
  type: REMOVE_PAYMENT_METHOD_ERROR, method: { type, id }, actionError,
});
export const removePaymentMethodBlockedDefault = ({ type, id }) => ({ type: REMOVE_PAYMENT_METHOD_BLOCKED_DEFAULT, method: { type, id } });
export const resetPaymentMethodsActionError = () => ({ type: RESET_PAYMENT_METHODS_ACTION_ERROR });

// #genai Phase 2 — "Payment method added" success banner handoff between Add-payment routes and
// the SavedPaymentMethods list. Message shape: { accountTypeLabel, accountSuffix, isDefault }.
// The second banner line ("Set as your default, this account will be billed on your next invoice.")
// is gated on message.isDefault, which mirrors the user's "Make this my default payment method"
// checkbox at submit time (isACHDefault for ACH / isDefaultMethod for card).
export const setRecentlyAddedPaymentMethod = (message) => ({ type: SET_RECENTLY_ADDED_PAYMENT_METHOD, message });
export const clearRecentlyAddedPaymentMethod = () => ({ type: CLEAR_RECENTLY_ADDED_PAYMENT_METHOD });
